var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=xl, Color=Success, Theme=Dark circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#039855",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M44.6673 31.9267V33C44.6659 35.5158 43.8512 37.9638 42.3449 39.9788C40.8385 41.9938 38.7211 43.4679 36.3086 44.1812C33.896 44.8945 31.3175 44.8089 28.9575 43.937C26.5976 43.0652 24.5827 41.4538 23.2134 39.3433C21.8441 37.2327 21.1937 34.7361 21.3593 32.2257C21.5248 29.7153 22.4974 27.3257 24.132 25.4133C25.7666 23.5008 27.9756 22.168 30.4295 21.6135C32.8835 21.0591 35.451 21.3127 37.749 22.3367M44.6673 23.6667L33.0007 35.345L29.5007 31.845",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLive);
export default __webpack_public_path__ + "static/media/success-live.802cb81f5f7ea1ee3b552fbfe28d9000.svg";
export { ForwardRef as ReactComponent };